import bus from "./bus.js";
import { addProducts } from "./adobeAnalytics.js";

export function buildDisplayProducts(vue) {
  const displayProducts = [];
  let productTCTI;
  let productSingle;
  let productSingleComprehensive;
  let productMulti8;
  let productMulti18;

  // Map the products from the Offer API results
  for(const category in vue.$store.state.products){
    for(const product of vue.$store.state.products[category].Products){
      switch(product.Product.ProductCode) {
        case "CIBCITripProTripCan":
        case "CIBCTripProTripCan":
        {
            productTCTI=product;
            break;
        }
        case "CIBCIMedicalPlan":
        case "CIBCMedicalPlan":
        {
            productSingle=product;
            break;
        }
        case "CIBCIComprehensive":
        case "CIBCComprehensive":
        {
            productSingleComprehensive=product;
            break;
        }
        case "CIBCIAnnual8Day":
        case "CIBCAnnual8Day":
        {
            productMulti8=product;
            break;
        }
        case "CIBCIAnnual18Day":
        case "CIBCAnnual18Day":
        {
            productMulti18=product;
            break;
        }
      }
    }
  }

  // Populate array of products to display.
  let tripLength = vue.$moment(vue.$store.state.returnDate,"MM/DD/YYYY").diff(vue.$moment(vue.$store.state.departureDate,"MM/DD/YYYY"),"days");
  tripLength=tripLength+1;
  const oldestTraveller = vue.$store.state.oldestTraveller;
  if(vue.$store.state.wantsCancellation===true&&vue.$store.state.wantsMedical===true){
    // Display both
    if(productSingleComprehensive!==undefined) {
      productSingleComprehensive.recommended = true;
      displayProducts.unshift(productSingleComprehensive);
    }
    if(productTCTI!==undefined) {
      displayProducts.push(productTCTI);
    }
    if(productSingle!==undefined) {
      displayProducts.push(productSingle);
    }
  } else if(vue.$store.state.wantsMedical===true){
    // Display Only Medical
    if(tripLength<=8){
      if(productSingle!==undefined) {
        displayProducts.push(productSingle);
      }
      if(productMulti8!==undefined) {
        productMulti8.recommended=true;
        displayProducts.push(productMulti8);
      }
      if(productMulti18!==undefined) {
        displayProducts.push(productMulti18);
      }
    } else if(tripLength <= "18"){
      if(productSingle!==undefined) {
        displayProducts.push(productSingle);
      }
      if(productMulti18!==undefined) {
        productMulti18.recommended=true;
        displayProducts.push(productMulti18);
      }
    } else {
      if(productSingle!==undefined) {
        productSingle.recommended=true;
        displayProducts.push(productSingle);
      }
      if(productSingleComprehensive!==undefined) {
        displayProducts.push(productSingleComprehensive);
      }
    }
  } else {
    // Display Only TCTI
    if(oldestTraveller>=60){
      if(productTCTI!==undefined) {
        displayProducts.push(productTCTI);
      }
    } else {
      if(productTCTI!==undefined) {
        displayProducts.push(productTCTI);
      }
      if(productSingleComprehensive!==undefined) {
        productSingleComprehensive.recommended=true;
        displayProducts.unshift(productSingleComprehensive);
      }
    }
  }

  if(displayProducts.length===0){
    bus.$emit("APIError", "RWEC0003");
  }
  else {
    //Add products to Analytics
    addProducts(displayProducts);
  }

  vue.$store.state.productCount=displayProducts.length;
  vue.$store.state.displayProducts=displayProducts;
}

export function constructProducts(vue){
  let displayProducts = vue.$store.state.displayProducts;
  // Populate array of Div's to populate with these products.
  let targetProducts = [
    document.getElementById("product1"),
    document.getElementById("product2"),
    document.getElementById("product3")
  ];
  buildProductHTML(vue, targetProducts, displayProducts);

  targetProducts = [document.getElementById("product1m")]
  if(displayProducts.length>=2) { targetProducts.push(document.getElementById("product2m")); }
  if(displayProducts.length>=3) { targetProducts.push(document.getElementById("product3m")); }
  buildProductHTML(vue, targetProducts, displayProducts);
}

export function buildProductHTML(vue, targetProducts, displayProducts){
  // Loop through these divs and display relavant info
  for(const product in targetProducts) {
    if(displayProducts[product]!==undefined) {
      // Fill out product card with results
      targetProducts[product].childNodes[1].childNodes[0].innerHTML = "<h2>"+displayProducts[product].Product.Name+"</h2>";
      // Pad the price with trailing 0's if required
      let price = Number(displayProducts[product].Total);
      let priceSuffix = "";
      const res = String(displayProducts[product].Total).split(".");
      if(res.length === 1 || res[1].length < 3) {
        price = price.toFixed(2);
      }
      // For CIBC member site only, add a * to the price
      if( vue.$store.state.site==="cibc") {
        priceSuffix=" *";
      }

      targetProducts[product].childNodes[1].childNodes[1].innerHTML = "$"+price+priceSuffix;

      // Display everything
      let currentBenefit=0;
      for(const benefit in displayProducts[product].Product.BenefitsDetails){
        targetProducts[product].childNodes[1].childNodes[2].childNodes[currentBenefit].innerHTML = displayProducts[product].Product.BenefitsDetails[benefit];
        currentBenefit++;
      }
      if(displayProducts[product].recommended===true){
        targetProducts[product].childNodes[0].innerHTML=vue.$i18n.t('text.suggested');
        targetProducts[product].childNodes[1].childNodes[0].childNodes[0].setAttribute("aria-label",displayProducts[product].Product.Name+" "+ vue.$i18n.t('text.suggested'));
      }
      targetProducts[product].childNodes[1].childNodes[3].setAttribute("aria-label",vue.$i18n.t("text.select")+" "+displayProducts[product].Product.Name +", "+targetProducts[product].childNodes[0].innerHTML);
      targetProducts[product].childNodes[1].childNodes[3].setAttribute("data-product",displayProducts[product].Product.ProductCode);
      targetProducts[product].childNodes[1].childNodes[4].childNodes[0].setAttribute("data-product",displayProducts[product].Product.ProductCode);
      targetProducts[product].childNodes[1].childNodes[4].childNodes[0].setAttribute("aria-label",vue.$i18n.t("text.moredetailson")+" "+displayProducts[product].Product.Name +", "+targetProducts[product].childNodes[0].innerHTML);
    }
    else {
      // Hide extra cards.
      targetProducts[product].classList.add("d-none");
    }
  }
}